import React from 'react'
import type { DialogProps, HeadingProps } from 'react-aria-components'
import { OverlayTriggerStateContext, Dialog as RACDialog } from 'react-aria-components'
import Button from './Button'
import type { ButtonProps } from './Button'
import { customTwMerge } from '~/lib/tv'

export { DialogTrigger, Heading } from 'react-aria-components'

type DialogFooterProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

type DialogBodyProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

type DialogContentProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

type DialogCloseProps = ButtonProps & {
  className?: string
}

export function DialogHeading({ children, className, ...props }: HeadingProps) {
  return (
    <div className={customTwMerge('flex flex-col justify-end gap-2', className)} {...props}>
      <div className="flex justify-between text-lg font-bold">{children}</div>
      <span className="w-full h-[2px] bg-gray-40"></span>
    </div>
  )
}
export function DialogFooter({ children, className, ...props }: DialogFooterProps) {
  return (
    <div className={customTwMerge('mt-6 flex justify-end gap-2', className)} {...props}>
      {children}
    </div>
  )
}
export function DialogBody({ children, className, ...props }: DialogBodyProps) {
  return (
    <div className={customTwMerge('mt-3 min-h-12 text-sm', className)} {...props}>
      {children}
    </div>
  )
}

export function DialogContent({ children, className, ...props }: DialogContentProps) {
  return (
    <div className={customTwMerge('scroll-auto', className)} {...props}>
      {children}
    </div>
  )
}

export function DialogClose({ children, className, ...props }: DialogCloseProps) {
  let state = React.useContext(OverlayTriggerStateContext)!
  // TODO: precisa implementar o layout do botão fechar, não tem no figma ainda. De qualquer forma não é utilizado ainda. Quando for utilizar, implementar o layout e remover o comentário
  return (
    <Button
      className={customTwMerge('w-6 h-6 text-red-500 absolute right-0 top-0 stroke-2', className)}
      type="button"
      onPress={() => state.close()}
      {...props}
    >
      X
    </Button>
  )
}

export default function Dialog(props: DialogProps) {
  return (
    <RACDialog
      {...props}
      className={customTwMerge(
        'outline outline-0 p-8 [[data-placement]>&]:p-4 max-h-[inherit] overflow-auto relative',
        props.className,
      )}
    />
  )
}
